import React from "react";

const Privacy = () => {
  return (
    <div className="container my-5">
      <h2>Privacy Policy</h2>
      <p><strong>Effective date: 02.02.2025</strong></p>

      <h5>1. Collection and use of your personal information</h5>
      <p>
        Welcome to ToGoWith!
        <br />
        Dutiap inc. located at 651 N. Broad St. suite 206, Middletown, DE
        190709 (“us”, “we”, or “our”) operates ToGoWith (hereinafter referred to
        as “Service”).
        <br />
        Our Privacy Policy explains how we collect, safeguard and disclose data
        through the use of our Service.
        <br />
        We use your data to provide and improve the Service. By using the
        Service, you agree to the collection and use of data in accordance with
        this policy.
        <br />
        Unless otherwise defined in this Privacy Policy, the terms used in this
        Privacy Policy have the same meanings as in our Terms and Conditions.
        <br />
        Our Terms and Conditions (“Terms”) govern all use of our Service and
        together with the Privacy Policy constitute your agreement with us
        (“agreement”).
      </p>

      <h5>2. Data Collection and Use</h5>
      <p>
        We collect several types of data for various purposes to provide and
        improve our Service to you.
      </p>

      <h5>3. Types of Data Collected</h5>

      <h6>3.1. Personal Data</h6>
      <p>
        We can’t help you develop meaningful connections without some data about
        you (“Personal Data”), such as:
        <ul>
          <li>basic profile details: first name and last name, email address;</li>
          <li>photos that you upload to the Service;</li>
          <li>types of people you’d like to meet.</li>
        </ul>
        We also collect data generated as you use our services, for example
        access logs, as well as data from third parties, like when you access
        our services through a social media account.
        <br />
        Other users may provide data about you as they use our services. For
        instance, we may collect data about you from other users if they contact
        us about you.
        <br />
        We may receive your data from our partners, for instance, where ToGoWith
        ads are published on a partner’s websites and platforms (in which case
        they may pass along details on a campaign’s success).
        <br />
        We may use your Personal Data to contact you with newsletters, marketing
        or promotional materials and other data that may be of interest to you.
        You may opt-out of receiving any, or all, of these communications from
        us by following the unsubscribe link or by emailing at 
        <strong>support@togowith.com</strong>.
        <br />
        When you choose to participate in our promotions, events or contests, we
        collect the data that you use to register or enter. If you contact our
        customer care team, we collect the data you give us during the
        interaction. Sometimes, we monitor or record these interactions for
        training purposes and to ensure a high quality of service.
        <br />
        We may use your data for conduct research and analysis of users’
        behavior to:
        <ul>
          <li>improve our services and content;</li>
          <li>develop new features and services (for example, we may decide to build a new interests-based feature further to requests received from users).</li>
        </ul>
      </p>

      <h6>3.2. Usage Data</h6>
      <p>
        We may also collect data that your device sends whenever you use our
        Service (“Usage Data”). Such data may include:
        <ul>
          <li>computer's Internet Protocol address (e.g. IP address);</li>
          <li>type of device you are using;</li>
          <li>the pages of our Service that you visit;</li>
          <li>the time and date of your visit;</li>
          <li>the time spent on those pages;</li>
          <li>unique device identifiers;</li>
          <li>other diagnostic data.</li>
        </ul>
      </p>

      <h6>3.3. Tracking Cookies Data</h6>
      <p>
        We use cookies and similar tracking technologies to track the activity
        on our Service.
        <br />
        Cookies are files with a small amount of data which may include an
        anonymous unique identifier. Cookies are sent to your browser from a
        website and stored on your device. Other tracking technologies are also
        used such as beacons, tags and scripts to collect and track data and to
        improve and analyze our Service.
        <br />
        <strong>Examples of Cookies we use:</strong>
        <ul>
          <li>
            <strong>session Cookies:</strong> We use Session Cookies to operate
            our Service;
          </li>
          <li>
            <strong>preference Cookies:</strong> We use Preference Cookies to
            remember your preferences and various settings;
          </li>
          <li>
            <strong>security Cookies:</strong> We use Security Cookies for
            security purposes;
          </li>
          <li>
            <strong>advertising Cookies:</strong> Advertising Cookies are used
            to serve you with advertisements that may be relevant to you and
            your interests.
          </li>
        </ul>
      </p>

      <h5>4. Use of Data</h5>
      <p>
        Data protection law means that we can only use your data for certain
        reasons and where we have a legal basis to do so. Here are the reasons
        for which we process your data:
      </p>
      <h6>4.1. Providing our Services</h6>
      <p>We use some of your data to provide our services. Legal basis: contract, legitimate interests.</p>
      <h6>4.2. Improving our service</h6>
      <p>
        Testing features, interacting with feedback platforms and
        questionnaires, managing landing pages, heat mapping our site, traffic
        optimization and data analysis and research, including profiling and the
        use of machine learning and other techniques over your data and in some
        cases using third parties to do this.
        <br />
        Legal basis: contract, legitimate interests.
      </p>
      <h6>4.3. Customer support</h6>
      <p>
        Notifying you of any changes to our service, solving issues via live
        chat support, phone or email including any bug fixing.
        <br />
        Legal basis: contract.
      </p>
      <h6>4.4. Marketing purposes (with your consent)</h6>
      <p>
        Sending emails and messages about new features, products and services,
        and content.
        <br />
        Legal basis: consent.
      </p>

      <h5>5. Legal basis</h5>
      <h6>5.1. Consent</h6>
      <p>You have given clear consent for you to process your personal data for a specific purpose.</p>
      <h6>5.2. You can change your mind!</h6>
      <p>
        If you have previously given consent to our processing your data, you
        can freely withdraw such consent at any time by emailing us at{" "}
        <strong>support@togowith.com</strong>.
        <br />
        If we do not have another legal basis for processing your data, then we
        will stop processing your personal data. Otherwise, we may continue to
        do so subject to your legal rights.
      </p>
      <h6>5.3. Contract</h6>
      <p>
        Processing your data is necessary for a contract you have with us, or
        because we have asked you to take specific steps before entering into
        that contract (e.g. your name, login info, preferences).
      </p>
      <h6>5.4. Legitimate interests</h6>
      <p>
        Processing your data is necessary for our legitimate interests or the
        legitimate interests of a third party, provided those interests are not
        outweighed by your rights and interests. These legitimate interests are:
      </p>
      <ul>
        <li>gaining insights from your behavior on our website or in our app;</li>
        <li>delivering, developing and improving our Service;</li>
        <li>enabling us to enhance, customize or modify our services and communications;</li>
        <li>determining whether marketing campaigns are effective;</li>
        <li>enhancing data security.</li>
      </ul>
      <p>In each case, these legitimate interests are only valid if they are not outweighed by your rights and interests.</p>

      <h5>6. Retention of Data</h5>
      <p>
        We will retain your Personal Data only for as long as is necessary for
        the purposes set out in this Privacy Policy. We will retain and use your
        Personal Data to the extent necessary to comply with our legal
        obligations, resolve disputes, and enforce our legal agreements and
        policies.
        <br />
        Some data you can delete whenever you like, some data is deleted
        automatically, and some data we retain for longer periods of time when
        necessary. When you delete data, we follow a deletion policy to make
        sure that your data is safely and completely removed.
        <br />
        We will also retain Usage Data for internal analysis purposes.
      </p>

      <h5>7. Data retained for extended time periods for limited purposes</h5>
      <p>
        Sometimes, business and legal requirements oblige us to retain certain
        data, for specific purposes, for an extended period of time. For
        example, when we process a payment for you, or when you make a payment
        to us, we’ll retain this data for longer periods of time as required for
        tax or accounting purposes.
        <br />
        Reasons we might retain some data for longer periods of time include:
      </p>
      <ul>
        <li>security, fraud &amp; abuse prevention;</li>
        <li>financial record-keeping;</li>
        <li>complying with legal or regulatory requirements;</li>
        <li>ensuring the continuity of our services;</li>
        <li>direct communications.</li>
      </ul>

      <h5>8. Transfer of Data</h5>
      <p>
        Your data may be transferred to – and maintained on – computers located
        outside your state, province, country or other governmental jurisdiction
        where the data protection laws may differ from those of your
        jurisdiction.
        <br />
        We will take all steps reasonably necessary to ensure that your data is
        treated securely and in accordance with this Privacy Policy and no
        transfer of your Personal Data will take place to an organization or a
        country unless there are adequate controls in place.
      </p>

      <h5>9. Disclosure of Data</h5>
      <p>
        We may disclose personal data that we collect, or you provide:
      </p>
      <h6>9.1 Disclosure for Law Enforcement</h6>
      <p>
        Under certain circumstances, we may be required to disclose your
        Personal Data if required to do so by law or in response to valid
        requests by public authorities.
      </p>
      <h6>9.2 Business Transaction</h6>
      <p>
        If we or our subsidiaries are involved in a merger, acquisition, or
        asset sale, your Personal Data may be transferred.
      </p>
      <h6>9.3 Other cases</h6>
      <p>
        We may disclose your data also:
        <ul>
          <li>to our subsidiaries and affiliates;</li>
          <li>to contractors, service providers, and other third parties we use to support our business;</li>
          <li>to fulfil the purpose for which you provide it;</li>
          <li>with your consent in any other cases;</li>
          <li>
            if we believe disclosure is necessary or appropriate to protect the
            rights, property, or safety of the Company, our customers, or
            others.
          </li>
        </ul>
      </p>

      <h5>10. Security of Data</h5>
      <p>
        The security of your data is important to us, but remember that no
        method of transmission over the Internet, or method of electronic
        storage is 100% secure. While we strive to use commercially acceptable
        means to protect your Personal Data, we cannot guarantee its absolute
        security.
      </p>

      <h5>11. Your Data Protection Rights Under General Data Protection Regulation (GDPR)</h5>
      <p>
        If you are a resident of the European Union (EU) and European Economic
        Area (EEA), you have certain data protection rights, covered by GDPR.
        <br />
        We aim to take reasonable steps to allow you to correct, amend, delete,
        or limit the use of your Personal Data.
        <br />
        If you wish to be informed what Personal Data we hold about you and if
        you want it to be removed from our systems, please email us at{" "}
        <strong>support@togowith.com</strong>.
        <br />
        In certain circumstances, you have the following data protection rights:
        <ul>
          <li>the right to access, update or to delete the data we have on you;</li>
          <li>the right of rectification (to correct inaccurate or incomplete data);</li>
          <li>the right to object to our processing of your Personal Data;</li>
          <li>the right of restriction (request that we restrict the processing of your personal data);</li>
          <li>the right to data portability (copy of your Personal Data in a structured, machine-readable format);</li>
          <li>the right to withdraw consent at any time where we rely on your consent to process your personal data.</li>
        </ul>
        You have the right to complain to a Data Protection Authority about our
        collection and use of your Personal Data.
      </p>

      <h5>12. Service Providers</h5>
      <p>
        We may employ third party companies and individuals to facilitate our
        Service (“Service Providers”), provide Service on our behalf, perform
        Service-related services or assist us in analyzing how our Service is
        used.
        <br />
        These third parties have access to your Personal Data only to perform
        these tasks on our behalf and are obligated not to disclose or use it
        for any other purpose.
      </p>

      <h5>13. Analytics</h5>
      <p>We may use third-party Service Providers to monitor and analyze the use of our Service.</p>
      <h6>13.1 Google Analytics</h6>
      <p>
        Google Analytics is a web analytics service offered by Google that
        tracks and reports website traffic. This data is shared with other
        Google services and may be used to personalize ads within the Google
        network.
      </p>
      <h6>13.2 Behavioral Remarketing</h6>
      <p>We use remarketing services to advertise on third party websites to you after you visited our Service.</p>
      <h6>13.3 Google Ads (AdWords)</h6>
      <p>
        Google Ads (AdWords) remarketing service is provided by Google Inc.
        <br />
        You can opt-out of Google Analytics for Display Advertising and
        customize the Google Display Network ads by visiting the Google Ads
        Settings page:{" "}
        <a href="http://www.google.com/settings/ads" target="_blank" rel="noreferrer">
          http://www.google.com/settings/ads
        </a>
        .
      </p>

      <h5>14. Links to Other Sites</h5>
      <p>
        Our Service may contain links to other sites not operated by us. If you
        click a third party link, you will be directed to that third party's
        site. We strongly advise you to review the Privacy Policy of every site
        you visit. We have no control over and assume no responsibility for the
        content or practices of any third party.
      </p>

      <h5>15. Children's Privacy</h5>
      <p>
        Our Service does not address anyone under the age of 18 (“Children”). We
        do not knowingly collect personal data from anyone under 18. If you are
        a parent or guardian and you become aware that your Child has provided
        us with Personal Data, please contact us. If we discover that a Child
        under 18 has provided us with Personal Data, we will delete such data
        from our servers.
      </p>

      <h5>16. Changes to This Privacy Policy</h5>
      <p>
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page. We will
        let you know via email and/or a prominent notice on our Service, prior
        to the change becoming effective and update "effective date" at the top
        of this Privacy Policy.
        <br />
        You are advised to review this Privacy Policy periodically for any
        changes. Changes are effective when posted on this page.
      </p>

      <h5>17. Contact Us</h5>
      <p>
        You may contact us regarding the Service or these Terms at:{" "}
        <a href="mailto:support@togowith.com">support@togowith.com</a>.
      </p>
    </div>
  );
};

export default Privacy;
